import { useContext } from 'react';
import { BackendDispatchContext } from '../context/backend-context';
import { useEntityList } from './use-entity-list';

export const usePodcastEpisodeUserHistory = (userId: string) => {
  const { asyncActions } = useContext(BackendDispatchContext)

  return useEntityList(userId, 'podcast-episode', asyncActions!.loadPodcastUserHisotry.bind(asyncActions!))
}